import { useEffect } from 'react';
import { useBodyClass } from '~/hooks/use-body-class';
import { useBreakpointBelow } from '~/hooks/use-breakpoints';
import { DropdownerDrawer } from '~/modules/common/dropdowner/drawer';
import { DropdownerDropdown } from '~/modules/common/dropdowner/dropdown';
import { useDropdowner } from '~/modules/common/dropdowner/use-dropdowner';
import { useUIStore } from '~/modules/ui/ui-store';

/**
 * Renders dropdowns as drawers on mobile and popovers on desktop.
 */
export function Dropdowner() {
  const dropdown = useDropdowner((state) => state.dropdown);
  const isMobile = useBreakpointBelow('sm');
  const { lockUI, unlockUI } = useUIStore();

  useBodyClass({ 'dropdowner-open': !!dropdown });

  useEffect(() => {
    if (dropdown) {
      lockUI('dropdowner');
      return () => unlockUI('dropdowner');
    }
  }, [!!dropdown]);

  if (!dropdown) return null;
  if (isMobile) return <DropdownerDrawer dropdown={dropdown} />;
  return <DropdownerDropdown dropdown={dropdown} />;
}
